// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ef7e108f","406":"94f2bc66","453":"fd3b05aa"}[chunkId] + ".chunk.js";
};